
import axios from 'axios'

export const getDashboardTodaysAwards = async(organizationId, programId, type) => {
    const response = await axios.get(`/organization/${organizationId}/program/${programId}/dashboard?type=awards&subtype=${type}`)
    // console.log(response)
    return response.data
}

export const getDashboardTodaysRedumptions = async(organizationId, programId, type) => {
    const response = await axios.get(`/organization/${organizationId}/program/${programId}/dashboard?type=redumption&subtype=${type}`)
    // console.log(response)
    return response.data
}
export const getDashboardTodaysActiveParticipants = async(organizationId, programId) => {
    const response = await axios.get(`/organization/${organizationId}/program/${programId}/dashboard?type=participant`)
    // console.log(response)
    return response.data
}

export const getDashboardTopMerchants = async(organizationId, programId, duration, unit) => {
    unit = unit === '$' ? 0 : 1;
    const response = await axios.get(`/organization/${organizationId}/program/${programId}/dashboard/top-merchants/${duration}/${unit}`)
    // console.log(response)
    return response.data
}

export const getDashboardTopAwards = async(organizationId, programId, duration, unit) => {
    unit = unit === '$' ? 0 : 1;
    const response = await axios.get(`/organization/${organizationId}/program/${programId}/dashboard/top-awards/${duration}/${unit}`)
    // console.log(response)
    return response.data
}

export const getDashboardAwardDetail = async(organizationId, programId, duration, unit) => {
    unit = unit === '$' ? 0 : 1;
    const response = await axios.get(`/organization/${organizationId}/program/${programId}/dashboard/award-detail/${duration}/${unit}`)
    return response.data
}

export const getDashboardAwardPeerDetail = async(organizationId, programId, duration, unit) => {
    unit = unit === '$' ? 0 : 1;
    const response = await axios.get(`/organization/${organizationId}/program/${programId}/dashboard/award-peer-detail/${duration}/${unit}`)
    return response.data
}